// Shared formatting + loyalty constants (mirrors mobile src/theme.ts)

export const formatIDR = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

export const formatShort = (n) => {
  n = Number(n || 0);
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(n);
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return String(iso);
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }) +
      " " + d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return String(iso);
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const monthStartISO = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
};

export const CATEGORIES = [
  "Padel", "Badminton", "Minisoccer", "Hyrox", "Boxing", "Barre",
  "Strength & Conditioning", "Gym", "Cafe", "Store", "Events",
];

export const TIER_ORDER = ["Bronze", "Silver", "Gold", "Platinum", "Diamond"];
export const TIER_THRESHOLDS = {
  Bronze: 0, Silver: 5_000_000, Gold: 15_000_000, Platinum: 30_000_000, Diamond: 50_000_000,
};

export const TIER_META = {
  Bronze: { accent: "#C08457", bg: "#140F0B", border: "#3A2A1E", tagline: "Awal perjalanan Anda bersama HSC.",
    benefits: ["Akses aplikasi & Member Card digital", "Kumpulkan 1 poin / Rp2.000", "Booking lapangan & kelas"] },
  Silver: { accent: "#C7CBD1", bg: "#101113", border: "#33363B", tagline: "Konsistensi Anda mulai dihargai.",
    benefits: ["Semua benefit Bronze", "Prioritas booking kelas populer", "Penawaran voucher berkala"] },
  Gold: { accent: "#E7C25B", bg: "#15110A", border: "#4A3C1B", tagline: "Member setia dengan hak istimewa.",
    benefits: ["Semua benefit Silver", "Guest pass bulanan", "Diskon khusus cafe & store"] },
  Platinum: { accent: "#D9D9E0", bg: "#0E0F12", border: "#3C3F47", tagline: "Status premium dengan layanan prioritas.",
    benefits: ["Semua benefit Gold", "Prioritas lapangan jam sibuk", "Undangan event eksklusif"] },
  Diamond: { accent: "#8FD3E8", bg: "#0A1114", border: "#204049", tagline: "Puncak keanggotaan HSC. Legenda klub.",
    benefits: ["Semua benefit Platinum", "Personal concierge & PT session", "Akses semua event tanpa biaya"] },
};

export const tierAccent = (tier) => (TIER_META[tier] || TIER_META.Bronze).accent;

export const COURT_COUNTS = { Padel: 3, Badminton: 5, Minisoccer: 1 };
export const CLASS_CATS = ["Hyrox", "Boxing", "Barre", "Strength & Conditioning", "Calisthenic"];

export const courtsFor = (category) => {
  const n = COURT_COUNTS[category];
  if (!n) return [];
  return Array.from({ length: n }, (_, i) => (category === "Minisoccer" ? `Field ${i + 1}` : `Court ${i + 1}`));
};

export const PAY_STATUS_LABEL = { PAID: "Lunas", PARTIAL: "Belum Lunas", UNPAID: "Belum Bayar" };
